import { contentSize } from '../constants/Search';

export interface ISearchResult {
    resultsList: IRecords;
    navigation: INavigation;
    breadcrumbs: IBreadcrumb;
    'endeca:redirect': IUrl;
    searchAdjustments: ISearchAdjustments;
}

export interface ISearchAdjustments {
    adjustedSearches: IAdjustedSearches;
    originalTerms: string[];
    adjustedTerms: string;
}

export interface IAdjustedSearches {
    [key: string]: IAdjustedSearchesObject[];
}

export interface IAdjustedSearchesObject {
    autoPhrased: boolean;
    adjustedTerms: string;
    spellCorrected: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SearchSortingTranslations: any = {
    Relevance: 'sortTopRated',
    'Price (Ascending)': 'sortPriceLowHigh',
    'Price (Descending)': 'sortPriceHighLow'
};

export interface ITypeaheadResult {
    children: IDimensionSearchGroups[];
}
export interface IDimensionSearchGroups {
    dimensionSearchGroups: IDimensionSearchValues[];
}

export interface IDimensionSearchValues {
    dimensionSearchValues: IItemTypeahead[];
}

export interface IItemTypeahead {
    link: string;
    label: string;
    count: number;
}

export interface IRecords {
    recsPerPage: number;
    totalNumRecs: number;
    firstRecNum: number;
    lastRecNum: number;
    pagingActionTemplate: ILink;
    records: IRecord[];
    sortOptions: ISortOption[];
}

export interface IRecord {
    attributes: IAttributes;
    records: ISubRecord[];
}

export interface IAttributes {
    p_product_id: string[];
    s_sku_id: string[];
    content: string[];
    type: string[];
    c_node_id: string[];
}

export interface ISubRecord {
    attributes: ISubAttributes;
}

export interface ISubAttributes {
    s_sku_id: string[];
    c_template_title: string[];
    c_uri: string[];
    c_url_alias: string[];
    // @todo Needs to be updated after DRUPALPLAT-5595 is done
    c_meta_og_description?: string[];
}

export interface ILink {
    link: string;
}

export interface IUrl {
    link: {
        url: string;
    };
}

export interface ISortOption {
    label: string;
    link: string;
    selected: boolean;
}

export interface INavigation {
    navigation: INavigationItem[];
}

export interface INavigationItem {
    dimensionName: string;
    refinements: IRefinement[];
}

export interface IRefinement {
    count: number;
    label: string;
    link: string;
}

export interface INavigationFilter {
    dimensionName: string;
    refinementsValues: IRefinement[];
}

export interface IBreadcrumb {
    refinementCrumbs: IBreadcrumbFilter[];
}

export interface IBreadCrumbItem {
    dimensionName: string;
    label: string;
    link: string;
    removeAction: ILink;
}

export interface IBreadcrumbFilter {
    dimensionName: string;
    label: string;
    link: string;
    removeAction: ILink;
}

export interface IProdObjListItem {
    productId: string;
    defaultSkuId: string;
    skuIds: string[];
}

export interface IContentObjListItem {
    type: string;
    nId: string;
    articles: ISubRecord[];
}

export interface IArticleObjItem {
    nId: string;
    templateTitle: string;
    uri: string;
    urlAlias: string;
    shortDescription?: string;
}

export enum ItemTypes {
    sku = 'sku',
    product = 'product'
}

interface IItemParams {
    id: string;
}
export interface IProductParams extends IItemParams {
    defaultSkuId?: string;
    skusToDisplay?: string[];
    featured?: boolean;
}
export type ISkuParams = IItemParams;

type ItemByType = { [K in ItemTypes]: ISkuParams[] | IProductParams[] };

export interface IItemByType extends ItemByType {
    [K: string]: ISkuParams[] | IProductParams[];
}

export interface IItem {
    type: ItemTypes;
    params: ISkuParams | IProductParams;
}

export interface ISearchPaths {
    guidedSearch: string;
    typeahead: string;
}

export interface ISearchConfig {
    assemblerUrl: string;
    assemblerPaths: ISearchPaths;
    assemblerName: string;
}

export interface INumRecs {
    totalNumRecs: number;
    lastRecNum: number;
}

export interface IToutItem {
    nId: number | string;
    nPsn: number;
    nSize: contentSize;
}

export interface ITrendingTermItem {
    trendingTerm: string;
    link?: string;
    searchTerm?: string;
}

export interface IEnhancedConfig {
    toutItem?: IToutItem[];
    favoriteProducts?: IItem[];
    terms?: ITrendingTermItem[];
}

export interface IPropsSearchConfig {
    enhancedConfig?: IEnhancedConfig;
    minSearchLength?: number;
    searchDisplayFormat: string;
    enableContentSearch?: boolean;
    contentEnabledConfig?: IContentEnabledConfig;
}

export interface IContentEnabledConfig {
    enableContentArticle?: boolean;
    enableContentBanner?: boolean;
    enableContentTout?: boolean;
    enableContentVideo?: boolean;
}

export interface IProductGridBreakpoints {
    numColumnsMobile: number;
    numColumnsDesktop: number;
    numColumnsLargeScreen: number;
    numColumnsExtraLargeScreen: number;
}
